export enum PolarZIndexMap {
    BACKGROUND,
    FOREGROUND,
    HIGHLIGHT,
    LABEL,
}
